<template>
  <div>
    <div class="personal-center">
      <div class="personal-center-title">
        <span></span>基本信息
      </div>
      <div class="personal-center-from">
        <div class="personal-center-from-left">
          <p><span class="title">作者姓名</span> <span class="value">{{authorName}}</span></p>
          <p><span class="title">作者角色</span> <span class="value">{{authorRole | role}}</span></p>
          <p><span class="title">账号简介</span> <span class="value">{{accountProfile}}</span></p>
          <p><span class="title">稿件样例</span> <span class="value">{{contribution}}</span></p>
          <p><span class="title">关联业务</span> <span class="value" v-for="(item,index) in business" :key="index">{{item}}</span></p>
        </div>
        <div class="personal-center-from-right">
          <div class="personal-center-from-right-top">
            <div class="font">头像</div>
            <div class="img">
              <div class="demo-basic--circle">
                <div class="block">
                  <el-avatar :size="70" :src="imgUrl"></el-avatar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="personal-center-footer">
        <div class="personal-center-footer-button">
          <el-button type="primary" :disabled="isDoctor" @click="goUpdate" v-if="auditStatus > 1">{{auditStatus == 2 ? '修改' : '重新认证'}}</el-button>
        </div>
        <div class="personal-center-footer-info" v-if="isDoctor">
          <span class="text">* 京东认证医生，无法修改昵称，请通过“京东医生”APP修改！</span>
        </div>
        <div class="personal-center-footer-info" v-if="btnVisable">
          <span>*个人信息修改后，需重新审核，会在48小时内反馈</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { getContentUserInfo,getDoctorType } from '@/api/user'
import defaultImage from "@/assets/default-header.png";

export default {
  name: "detail",
  data() {
    return {
      imgUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      authorName: '',
      authorRole: '',
      accountProfile: '',
      contribution: 'https://portal1.jd.com:8445/PortalServer/customize',
      business: [],
      fileList: [],
      // 裁剪组件的基础配置option
      imgHost: '//image.healthjd.com/da/',
      defaultImage: defaultImage,
      auditStatus: 0,
      pin: '', // 用户的pin 用来请求用户是否为医生
      isDoctor: false,
    }
  },

  filters: {
    role: function(data) {
      switch (data) {
        case 0:
          return '其他';
        case 1:
          return '写手';
        case 2:
          return '医护';
        case 3:
          return '运营';
        default:
          return ''
      }
    }
  },
  computed: {
    ...mapState([
      'imgHost',
      'userInfo'
    ])
  },
  async created() {
    await this.getContentUserInfo();
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    ...mapMutations([
      'setUserInfo'
    ]),
    // 获取账户信息接口
    getContentUserInfo() {
      getContentUserInfo({
        tenantId: this.$commonJs.getTenantId()
      }).then(res => {
        // this.business = res.contentBusinessDTOList&&res.contentBusinessDTOList.join('')
        this.authorName = res.nickName
        this.authorRole = res.identity
        this.accountProfile = res.briefing
        this.contribution = res.exampleUrl
        this.auditStatus = res.auditStatus;
        this.pin = res.pin;
        res.headPic ? this.imgUrl = this.imgHost + res.headPic : this.imgUrl = defaultImage
        res.contentBusinessDTOs && res.contentBusinessDTOs.forEach(item => {
          this.business.push(item.name)
        })
        this.setUserInfo(res || {});
        this.getDoctorType();
      })
    },
    // 验证账号是不是医生账号
    getDoctorType() {
      getDoctorType({
        tenantId: Number(this.$commonJs.getTenantId()),
        pin: this.pin,
      }).then(res => {
        if(res?.pin) {
        //  if(this.$route.query.tenantid==287){
           this.isDoctor = true;
        //  }
        }
      })
    },

    goUpdate() {
      this.$confirm('修改认证信息，待审核内容将无法通过，账号会进入待审核状态，认证通过后可进行内容管理, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          path: `/personalCenter/update`,
          query: {
            imgUrl: this.imgUrl,
            authorName: this.authorName,
            authorRole: this.authorRole,
            accountProfile: this.accountProfile,
            contribution: this.contribution,
            business: this.business,
          }
        })
      });
    },

  }
}

</script>
<style lang="scss" scoped>
.personal-center {
  &-title {
    span {
      display: inline-block;
      width: 3px;
      height: 12px;
      // border: 1px solid #1D61FF;
      background-color: #1D61FF;
      margin-right: 6px;
    }

    color: #2E3646;
    font-size: 14px;
    font-weight: bold;
  }

  &-from {
    padding: 10px;
    display: flex;

    &-left {
      flex-grow: 3;

      p {
        margin-top: 32px;
        display: flex;
        align-items: center;

        .title {
          color: #8B8C9A;
          width: 103px;
        }

        .value {
          margin-left: 15px;
          white-space: normal;
          word-break: break-all;
          color: rgba(44, 52, 67, 1);
          line-height: 14px;
        }

        &:nth-child(4) {
          .value {
            margin-left: 12px;
            margin-top: 4px;
          }
        }
      }
    }

    &-right {
      flex-grow: 1;
      flex-shrink: 0;
      color: #2C3443;

      /*position: absolute;*/
      /*right: 170px;*/
      /*top: 171px;*/
      &-top {
        display: flex;

        .font {
          flex-grow: 0.5;
          padding: 10px;
        }

        .img {
          flex-grow: 2;

          .block {
            width: 84px;
            border: 1px dashed #8B8C9A;
            height: 84px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
          }

          .upload {
            .el-button--primary {
              background-color: #1D61FF;
            }

            .el-upload-list {
              display: none;
            }

            .el-upload--picture-card {
              background: none;
              border: none;
              width: 80px;
              height: 32px;
              line-height: 32px;
            }

            margin-top: 10px;
          }
        }
      }

      &-bottom {
        margin-top: 22px;
        color: #FF9B39;
      }
    }
  }

  &-footer {
    padding: 10px;
    margin-top: 40px;

    &-button {
      display: flex;
      align-items: flex-end;
    }

    &-info {
      margin-top: 10px;
      color: #9CA8B9;
      .text {
        color: red;
        margin-left: 5px;
      }
    }
  }
}

.isShow {
  display: none;
}

</style>
